import { render } from "./ManageStudent.vue?vue&type=template&id=11ff38b7&scoped=true"
import script from "./ManageStudent.vue?vue&type=script&lang=js"
export * from "./ManageStudent.vue?vue&type=script&lang=js"

import "./ManageStudent.vue?vue&type=style&index=0&id=11ff38b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ff38b7"]])

export default __exports__